<template>
  <!-- 翻牌子抽奖 -->
  <div class="container">
    <div
      class="cardItem"
      :class="[
        floating && (card.id % 2 === 0 ? 'floatUp' : 'floatDown'),
        card.id === currentShowOutId && 'showOut'
      ]"
      v-for="card in cards"
      :key="card.id"
      @click="handleTap(card.id)"
    >
      <div class="cardFace" :style="cardFrontBgStyle"></div>
      <div class="cardFace" :style="cardBackBgStyle"></div>
    </div>
  </div>
</template>

<script>
function delay(msTime) {
  return new Promise(resolve => {
    setTimeout(resolve, msTime);
  });
}

const STOP_FLOAT_DURING_TIME = 200; // 停止浮动动画时长
const SHOW_OUT_CARD_DURING_TIME = 800; // 翻开卡片动画时长
export default {
  data() {
    return {
      floating: true,
      currentShowOutId: -1,
      lotteryPending: false,
      cards: [
        {
          id: 1
        },
        {
          id: 2
        },
        {
          id: 3
        }
      ]
    };
  },
  props: {
    lotterySetting: Object,
    lotteryResult: Array,
    lotteryTicketCount: Number
  },
  watch: {
    lotteryResult: function(newVal, oldVal) {
      if (!oldVal && newVal) {
        this.$emit('lotteryFinish');
        if (newVal.length) {
          this.reportDraw(1);
        } else {
          this.reportDraw(0);
        }
      }
      if (oldVal && !newVal) {
        this.reset();
      }
    }
  },
  computed: {
    cardFrontBgStyle() {
      return {
        backgroundImage: `url("${this.lotterySetting.cardFrontImage}")`,
        transform: 'rotateY(180deg)'
      };
    },
    cardBackBgStyle() {
      return {
        backgroundImage: `url("${this.lotterySetting.cardBackImage}")`
      };
    }
  },
  methods: {
    checkTicket() {
      const hasTicket = this.lotteryTicketCount > 0;
      if (!hasTicket) {
        this.$emit('noTicket');
      }
      return hasTicket;
    },
    stopCardFloating() {
      this.floating = false;
    },
    startCardFloating() {
      this.floating = true;
    },
    openCardById(id) {
      this.currentShowOutId = id;
    },
    closeAllCard() {
      this.currentShowOutId = -1;
    },
    async handleTap(id) {
      if (this.lotteryPending) {
        return;
      }
      if (!this.checkTicket()) {
        this.reportDraw(0);
        return;
      }
      this.lotteryPending = true;
      // 停止卡片漂浮
      this.stopCardFloating();
      await delay(STOP_FLOAT_DURING_TIME);
      // 翻开卡片
      this.openCardById(id);
      await delay(SHOW_OUT_CARD_DURING_TIME);
      this.$emit('fire');
    },
    reset() {
      this.startCardFloating();
      this.closeAllCard();
      this.lotteryPending = false;
    },
    reportDraw(is_success = 1) {
      this.$emit('reportDraw', {
        is_success
      });
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  box-sizing: border-box;
  padding: 0 26px;
  display: flex;
  justify-content: space-between;
  perspective: 800px;

  .cardItem {
    width: 190px;
    height: 240px;
    transform-style: preserve-3d;

    &.showOut {
      transition: transform 1s;
      transform: rotateY(-180deg);
    }

    .cardFace {
      position: absolute;
      width: 100%;
      height: 100%;
      backface-visibility: hidden;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    }

    &.floatDown {
      animation: floatDown 2s linear infinite;
    }

    &.floatUp {
      animation: floatUp 2s linear infinite;
    }
  }
}
@keyframes floatDown {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(12%);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes floatUp {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-12%);
  }
  100% {
    transform: translateY(0);
  }
}
</style>
